import React from 'react';
import logo from './logo.svg';
import './App.css';
import FormComponent from "./components/FormComponent";
import {initGA, initGTM} from "./globan-app-elements/ga_function";

function App() {
    initGTM();
    initGA();
  return (
      <>
   <FormComponent/>
   </>
  );
}

export default App;
